import React, { useEffect, useState } from "react";
import { Flex, FormControl, FormLabel, Image, Input } from "@chakra-ui/react";
import { ContentControls } from "./ContentControls";
import { PimcoreImage } from "./PimcoreImage";
import { FaImage } from "react-icons/fa";
import { useFocus } from "./useFocus";
import { useAssetResolver } from "./ContentManagementProvider";
import { PimcoreLink } from "./PimcoreLink";
import { PimcoreLinkButton } from "../components/PimcoreLinkButton";
const defaults = {
    asset: null,
    maxHeight: "",
    maxWidth: "",
    link: {
        path: "",
        parameters: "",
        anchor: "",
        accesskey: "",
        rel: "",
        tabindex: "",
        target: "",
        class: "",
        attributes: ""
    }
};
function isImage(element) {
    return element.type === "image";
}
export const ImageContentElement = (props) => {
    var _a, _b;
    const [ref, setRef] = useState(null);
    const [asset, setAsset] = useState(null);
    const { containerProps, isActive } = useFocus(props.contentElement.id);
    const resolver = useAssetResolver();
    const data = Object.assign(Object.assign({}, defaults), props.contentElement.data);
    useEffect(() => {
        if (!isImage(props.contentElement) || props.contentElement.data == null) {
            const element = Object.assign(Object.assign({}, props.contentElement), { type: "image", data: defaults });
            props.onChange(element);
        }
    }, [props.contentElement]);
    useEffect(() => {
        var _a;
        if (isImage(props.contentElement) && ((_a = props.contentElement.data) === null || _a === void 0 ? void 0 : _a.asset)) {
            resolver(props.contentElement.data.asset.id, "WebLarge").then((asset) => setAsset(asset));
        }
    }, [props.contentElement]);
    if (!isImage(props.contentElement) || props.contentElement.data == null) {
        return React.createElement(React.Fragment, null);
    }
    const image = (React.createElement(Image, { src: (_b = (_a = asset === null || asset === void 0 ? void 0 : asset.thumbnails) === null || _a === void 0 ? void 0 : _a.WebLarge) !== null && _b !== void 0 ? _b : asset === null || asset === void 0 ? void 0 : asset.url, borderRadius: "3xl", maxHeight: props.contentElement.data.maxHeight, maxWidth: props.contentElement.data.maxWidth, fallback: React.createElement(Flex, { justifyContent: "center", alignItems: "center", p: 4, bg: "gray.50" },
            React.createElement(FaImage, null)) }));
    return (React.createElement(Flex, Object.assign({ ref: setRef }, containerProps),
        ref && isActive &&
            React.createElement(ContentControls, { onUp: props.onUp, onDown: props.onDown, onDelete: props.onDelete, label: "Image", attachTo: ref },
                React.createElement(FormControl, null,
                    React.createElement(FormLabel, null, "Image"),
                    React.createElement(PimcoreImage, { data: props.contentElement.data.asset, onChange: data => props.onChange(Object.assign(Object.assign({}, props.contentElement), { data: Object.assign(Object.assign({}, props.contentElement.data), { asset: data }) })) })),
                React.createElement(FormControl, null,
                    React.createElement(FormLabel, null, "Link Image to"),
                    React.createElement(PimcoreLink, { link: data.link, onChange: data => props.onChange(Object.assign(Object.assign({}, props.contentElement), { data: Object.assign(Object.assign({}, props.contentElement.data), { link: data }) })) })),
                React.createElement(FormControl, null,
                    React.createElement(FormLabel, null, "Max Height"),
                    React.createElement(Input, { value: props.contentElement.data.maxHeight, onChange: (event) => props.onChange(Object.assign(Object.assign({}, props.contentElement), { data: Object.assign(Object.assign({}, props.contentElement.data), { maxHeight: event.target.value }) })) })),
                React.createElement(FormControl, null,
                    React.createElement(FormLabel, null, "Max Width"),
                    React.createElement(Input, { value: props.contentElement.data.maxWidth, onChange: (event) => props.onChange(Object.assign(Object.assign({}, props.contentElement), { data: Object.assign(Object.assign({}, props.contentElement.data), { maxWidth: event.target.value }) })) }))),
        data.link.path !== "" ?
            React.createElement(PimcoreLinkButton, { variant: "link", link: data.link }, image)
            : image));
};
